var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "21px",
    viewBox: "0 0 25 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.529412 0 0 0 0 0.533333 0 0 0 0 0.545098 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profile-page",
    transform: "translate(-979.000000, -371.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Socail",
    transform: "translate(931.000000, 170.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 200.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.4668159,6.82135685 C70.482447,7.04009641 70.482447,7.25888406 70.482447,7.47762361 C70.482447,14.1494686 65.4043515,21.837 56.1230706,21.837 C53.263681,21.837 50.6074479,21.008839 48.3730628,19.5714007 C48.7793278,19.618246 49.1699135,19.6338771 49.5918096,19.6338771 C51.9511475,19.6338771 54.1230562,18.8370265 55.8574377,17.4776477 C53.6386837,17.4307543 51.7793013,15.9776368 51.1386657,13.9776224 C51.451192,14.0244677 51.7636702,14.0557299 52.0918276,14.0557299 C52.5449379,14.0557299 52.9980962,13.9932054 53.4199442,13.8838838 C51.1074515,13.4150943 49.3730219,11.3838657 49.3730219,8.93074106 L49.3730219,8.86826465 C50.0448717,9.24326736 50.8261875,9.47763804 51.6542523,9.50885219 C50.2948735,8.60258363 49.4042842,7.05572753 49.4042842,5.30571491 C49.4042842,4.36823219 49.6542379,3.508857 50.0917651,2.75885159 C52.576152,5.82134964 56.3105479,7.82131597 60.498006,8.04010362 C60.4198985,7.66510091 60.3730051,7.27451518 60.3730051,6.88388135 C60.3730051,4.10259926 62.6230213,1.837 65.4198865,1.837 C66.8730039,1.837 68.1854893,2.44637338 69.107389,3.43074947 C70.2479802,3.21200992 71.341726,2.79011384 72.3105191,2.21200271 C71.9354683,3.3839042 71.1386176,4.36828029 70.0917651,4.9932367 C71.1074034,4.88391502 72.0917795,4.60260287 72.998,4.21201713 C72.3106153,5.21197625 71.451192,6.10256559 70.4668159,6.82135685 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.905e3beac12a403f16f5614aa14648b9.svg";
export { ForwardRef as ReactComponent };